import localeCs from '@angular/common/locales/cs';
import localeDe from '@angular/common/locales/de';
import localeEn from '@angular/common/locales/en';
import localeEs from '@angular/common/locales/es';
import localeFr from '@angular/common/locales/fr';
import localeHu from '@angular/common/locales/hu';
import localeIt from '@angular/common/locales/it';
import localeNl from '@angular/common/locales/nl';
import localePl from '@angular/common/locales/pl';
import localeSk from '@angular/common/locales/sk';

import localeCsExtra from '@angular/common/locales/extra/cs';
import localeDeExtra from '@angular/common/locales/extra/de';
import localeEnExtra from '@angular/common/locales/extra/en';
import localeEsExtra from '@angular/common/locales/extra/es';
import localeFrExtra from '@angular/common/locales/extra/fr';
import localeHuExtra from '@angular/common/locales/extra/hu';
import localeItExtra from '@angular/common/locales/extra/it';
import localeNlExtra from '@angular/common/locales/extra/nl';
import localePlExtra from '@angular/common/locales/extra/pl';
import localeSkExtra from '@angular/common/locales/extra/sk';

import { Locale } from 'date-fns';
import { cs, de, enGB, es, fr, hu, it, nl, pl, sk } from 'date-fns/locale';
import { LanguageCode } from './language-code';

/**
 * Data model representing frontend language information for internationalization (i18n).
 */
type LanguageFEModel = {
    angularLocale: unknown; // Locale angular data
    angularLocaleExtra: unknown; // Extra locale angular data
    dateFnsLocale: Locale; // For DateAdapter
    dateFormat: string; // For datepicker hint
    flagCode: string; // 'flags.scss' with flag icon styles.
    phonePrefix: string;
};

/**
 * Associates language codes with an object containing various properties for frontend
 * internationalization (i18n) usage. Each entry includes Angular locale information, Angular locale extra information,
 * DateFns locale and flag code.
 */
export const langCodeToIntlFEData = new Map<LanguageCode, LanguageFEModel>([
    [
        'cs',
        {
            angularLocale: localeCs,
            angularLocaleExtra: localeCsExtra,
            dateFnsLocale: cs,
            dateFormat: 'DD.MM.YYYY',
            flagCode: 'cz',
            phonePrefix: '+420',
        },
    ],
    [
        'de',
        {
            angularLocale: localeDe,
            angularLocaleExtra: localeDeExtra,
            dateFnsLocale: de,
            dateFormat: 'DD.MM.YYYY',
            flagCode: 'de',
            phonePrefix: '+49',
        },
    ],
    [
        'en',
        {
            angularLocale: localeEn,
            angularLocaleExtra: localeEnExtra,
            dateFnsLocale: enGB,
            dateFormat: 'DD/MM/YYYY',
            flagCode: 'gb',
            phonePrefix: '+44',
        },
    ],
    [
        'es',
        {
            angularLocale: localeEs,
            angularLocaleExtra: localeEsExtra,
            dateFnsLocale: es,
            dateFormat: 'DD/MM/YYYY',
            flagCode: 'es',
            phonePrefix: '+34',
        },
    ],
    [
        'fr',
        {
            angularLocale: localeFr,
            angularLocaleExtra: localeFrExtra,
            dateFnsLocale: fr,
            dateFormat: 'DD/MM/YYYY',
            flagCode: 'fr',
            phonePrefix: '+33',
        },
    ],
    [
        'hu',
        {
            angularLocale: localeHu,
            angularLocaleExtra: localeHuExtra,
            dateFnsLocale: hu,
            dateFormat: 'DD/MM/YYYY',
            flagCode: 'hu',
            phonePrefix: '+36',
        },
    ],
    [
        'it',
        {
            angularLocale: localeIt,
            angularLocaleExtra: localeItExtra,
            dateFnsLocale: it,
            dateFormat: 'DD/MM/YYYY',
            flagCode: 'it',
            phonePrefix: '+39',
        },
    ],
    [
        'nl',
        {
            angularLocale: localeNl,
            angularLocaleExtra: localeNlExtra,
            dateFnsLocale: nl,
            dateFormat: 'DD/MM/YYYY',
            flagCode: 'nl',
            phonePrefix: '+31',
        },
    ],
    [
        'pl',
        {
            angularLocale: localePl,
            angularLocaleExtra: localePlExtra,
            dateFnsLocale: pl,
            dateFormat: 'DD.MM.YYYY',
            flagCode: 'pl',
            phonePrefix: '+48',
        },
    ],
    [
        'sk',
        {
            angularLocale: localeSk,
            angularLocaleExtra: localeSkExtra,
            dateFnsLocale: sk,
            dateFormat: 'DD.MM.YYYY',
            flagCode: 'sk',
            phonePrefix: '+421',
        },
    ],
]);
